import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
    AdmByStdInterface,
    AdminDashboardSummaryInterface,
    DashboardActivtyInterface,
    FeesByStdInterface,
    FeesPaymentTrendInterface,
} from "../../interfaces";

@Injectable({ providedIn: "root" })
export class DashboardService {
    constructor(private httpClient: HttpClient) {}

    getAdminDashboard(): Observable<AdminDashboardSummaryInterface> {
        return this.httpClient.get<AdminDashboardSummaryInterface>(`${environment.API_URL}/admin/dashboard/summary/`);
    }
    // getAdminDashboard(): Observable<AdminDashboardSummaryInterface> {
    //     return this.httpClient.get<AdminDashboardSummaryInterface>(
    //         `${environment.API_URL}/admin/dashboard/announcements/`,
    //     );
    // }
    getAdminDashboardActivities(): Observable<DashboardActivtyInterface> {
        return this.httpClient.get<DashboardActivtyInterface>(`${environment.API_URL}/admin/dashboard/activities/`);
    }
    getAdminDashboardFeesByStd(): Observable<FeesByStdInterface[]> {
        return this.httpClient.get<FeesByStdInterface[]>(`${environment.API_URL}/admin/dashboard/standard-wise-fees/`);
    }

    getAdminDashboardFeesTrendByYear(): Observable<FeesPaymentTrendInterface[]> {
        return this.httpClient.get<FeesPaymentTrendInterface[]>(
            `${environment.API_URL}/admin/dashboard/fees-payment-trend/`,
        );
    }

    getAdminDashboardAdmByStd(): Observable<AdmByStdInterface[]> {
        return this.httpClient.get<AdmByStdInterface[]>(`${environment.API_URL}/admin/dashboard/admission-by-standard`);
    }
}
